import React from 'react';

const ProgressBar = ({ current, total, answeredCount }) => {
  // Calculate progress percentage
  const progressPercentage = Math.round((answeredCount / total) * 100);
  
  return (
    <div className="mb-8">
      <div className="flex justify-between items-center mb-2">
        <h2 className="text-lg font-semibold text-gray-700">Progres:</h2>
        <div className="flex items-center text-blue-600 font-medium">
          <span>{answeredCount}</span>
          <span className="mx-1">dari</span>
          <span>{total}</span>
          <span className="ml-1 text-gray-500">pertanyaan</span>
          <span className="ml-2 bg-blue-100 text-blue-800 py-1 px-2 rounded-full text-xs font-bold">
            {progressPercentage}%
          </span>
        </div>
      </div>
      
      <div className="h-2.5 bg-gray-200 rounded-full overflow-hidden shadow-inner">
        <div 
          className="h-full bg-blue-500 rounded-full transition-all duration-500 ease-out"
          style={{ width: `${progressPercentage}%` }}
        />
      </div>
      
      <div className="mt-3 flex justify-between text-sm font-medium">
        <div className="text-gray-600">
          Pertanyaan {current} dari {total}
        </div>
        <div className="text-blue-600">
          {total - answeredCount > 0 ? (
            `${total - answeredCount} pertanyaan belum dijawab`
          ) : (
            <span className="text-green-600 font-semibold">Semua pertanyaan telah dijawab</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;